import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCountry, selectPayment, selectDelivery, selectDispatchPoint } from '@store/order/selectors';
import { useLazyGetPaymentTypesQuery } from '@api/baseApi';
import { getFormattedPrice } from '@translations/functions';



const PaymentShipping = () => {
	const { t } = useTranslation('forms');

	const country = useSelector(selectCountry);
	const payment = useSelector(selectPayment);
	const delivery = useSelector(selectDelivery);
	const dispatchPoint = useSelector(selectDispatchPoint);

	const [ getPayments, { data, isLoading, isFetching, isError } ] = useLazyGetPaymentTypesQuery();

	useEffect(() => {
		if (country) {
			getPayments({ country }, true);
		}
	}, [ country ]);

	const selectedPayment = data && data.length > 0 && payment ? data.find(x => x.id === payment.id) : null;

	if (isError || isFetching || isLoading || !selectedPayment || !delivery) return (
		<div className='order-summary-element'>
		</div>
	)

	return (
		<>
			<div className='order-summary-element'>

				<h2>{t('paymentShipping.payment.sectionLabel')}</h2>

				<div className='summary-property'>
					<p>{`${selectedPayment.description} (${
						selectedPayment.price === 0 ? t('units.free') : getFormattedPrice(country, selectedPayment.price)
					})`}</p>
				</div>

			</div>


			<div className='order-summary-element'>

				<h2>{t('paymentShipping.shipping.sectionLabel')}</h2>

				<div className='summary-property'>
					<p>{`${delivery.description} (${
						delivery.price === 0 ? t('units.free') : getFormattedPrice(country, delivery.price)
					})`}</p>
				</div>

			</div>

			{dispatchPoint !== null && dispatchPoint !== undefined &&
				<div className='order-summary-element'>

					<h2>{t('paymentShipping.shipping.dispatchPointLabel')}</h2>

					<div className='summary-property'>
						<p>{dispatchPoint.name}</p>
					</div>

				</div>
			}

		</>
	);
};

export default PaymentShipping;